export const PVZColumns = [
    {
        name: 'ID',
        key: 'id',
    },
    {
        name: 'Название',
        key: 'name',
    },
    {
        name: 'Город',
        key: 'city',
    },
    {
        name: 'Телефон',
        key: 'phone',
    },
    {
        name: 'Адрес',
        key: 'full_address',
    },
]

export const PVZInovicesColumns = [
    {
        name: 'ФИО получателя',
        key: 'receiver_full_name',
    },
    {
        name: 'Статус',
        key: 'status',
    },
    {
        name: 'Номер накладной',
        key: 'invoice_number',
    },
    {
        name: 'Телефон получателя',
        key: 'receiver_phone_number',
    },
    {
        name: 'Количество мест',
        key: 'places_quantity',
    },
    {
        name: 'Вес',
        key: 'weight',
    },
    {
        name: 'Объёмный вес',
        key: 'volume_weight',
    },
]
